import React from 'react'
import { bool, func, object, oneOf, string } from 'prop-types'
import { translate } from 'react-i18next'
import { InquiryTypes } from '../../../constants/InquiryTypes'
import { InquiryFrequencies } from '../../../constants/InquiryFrequencies'
import { InquiryDetailsProposalCount } from '../../../components/inquiries/InquiryDetailsProposalCount'
import { InquiryDetailsProposal } from '../../../components/inquiries/InquiryDetailsProposal'
import { QuotationButtons } from '../../../components/ui/buttons/QuotationButtons'
import { SelectGardenerButton } from '../../../components/ui/buttons/SelectGardenerButton'
import { InquiryDetailsPayment } from '../../../components/inquiries/InquiryDetailsPayment'
import { Loader } from '../../../components/ui/states/Loader'
import { stores } from '../../../stores'
import { Accordion } from '../../../components/accordion/Accordion'
import DebitPaymentContent from '../../../components/customer/wallet/payments/debit/DebitPaymentContent'
import TransfertPaymentContent from '../../../components/customer/wallet/payments/transfert/TransfertPaymentContent'
import ChequePaymentContent from '../../../components/customer/wallet/payments/cheque/ChequePaymentContent'
import CesuPaymentContent from '../../../components/customer/wallet/payments/cesu/CesuPaymentContent'
import { InquiryDetailsTextBlock } from '../../../components/inquiries/InquiryDetailsTextBlock'
import api from '../../../api'
import { view } from '@risingstack/react-easy-state'
import { Link } from 'react-router-dom'
import { PagesPaths } from '../../../constants/Pages'

export const MaintenanceProposalsWaiting = translate()(({
  t, type, frequency, onSelect, selected, payment, inquiry, hidden, asAdmin
}) => (
  <div className='demandes__section'>
    <InquiryDetailsProposalCount count={inquiry.proposals ? inquiry.proposals.length : 0} />
    {
      inquiry.proposals.map((p) => (
        <div key={p.id}>
          <InquiryDetailsProposal proposal={p} only={selected} type={type} frequency={frequency}>
            {asAdmin ? <div>
              <button
                onClick={() => onSelect({ id: p.id, asAdmin: true, paymentType: 'DIRECT_DEBIT' })}
                className='btn--red demandes__button'
                style={{ background: 'red' }}>{t(`common:jardiniers:button_choose_admin`)}</button>
              <button
                onClick={() => onSelect({ id: p.id, asAdmin: true, paymentType: 'CHEQUE' })}
                className='btn--red demandes__button'
                style={{ background: 'red' }}>{t(`common:jardiniers:button_choose_admin_cheque`)}</button>
              <button
                onClick={() => onSelect({ id: p.id, asAdmin: true, paymentType: 'CESU' })}
                className='btn--red demandes__button'
                style={{ background: 'red' }}>{t(`common:jardiniers:button_choose_admin_cesu`)}</button>
              <button
                onClick={() => onSelect({ id: p.id, asAdmin: true, paymentType: 'AVANCE_IMMEDIATE' })}
                className='btn--red demandes__button'
                style={{ background: 'red' }}>{t(`common:jardiniers:button_choose_admin_avance_immediate`)}</button>
            </div> : ''}
            <QuotationButtons proposal={p} />
          </InquiryDetailsProposal>
          <Accordion isPrimary title={t('common:jardiniers:button_choose')}
            additionalComponent={<PaymentTypes proposal={p} onSelect={onSelect} />} />
        </div>
      ))
    }
    {
      payment && payment.loading
        ? <Loader size='medium' message={t('common:visits:payment_loading')} />
        : ''
    }
    {
      payment && payment.total !== undefined
        ? <InquiryDetailsPayment payment={payment} />
        : ''
    }
  </div>
))

const PaymentTypes = translate()(view(({ t, proposal, onSelect }) => {
  const { wallet, mandate } = stores.account
  const isContractStartDateInPast = proposal.maintenance.contractStartDate < Date.now() / 1000
  if (isContractStartDateInPast) {
    return <p>{t('common:payment:expired_contract', { gardenerPhone: proposal.professionalPhoneNumber })}</p>
  }
  // Le prélèvement n'existe que par la plateforme de paiement, et un client inscrit depuis qu'on ne
  // lui y ouvre plus de compte n'aura jamais de mandat. Lui proposer l'option l'envoyait sur un bloc
  // qui réclame une pièce d'identité et un RIB pour un mandat que personne ne pourra préparer.
  // `=== false` et non `!` : tant que le statut charge, ou s'il n'a pas pu être lu, on garde l'option
  // — on ne la retire que sur une réponse ferme, comme le fait déjà MandatePaymentType plus bas.
  const isDirectDebitOffered = mandate.available !== false
  return <div>
    Afin de valider votre choix, veuillez choisir un mode de paiement:
    {isDirectDebitOffered && (
      <Accordion
        title={t('common:payment:possibilities:direct_debit')}
        additionalComponent={
          <MandatePaymentType
            proposal={proposal}
            onSelect={() => onSelect({ id: proposal.id, paymentType: 'DIRECT_DEBIT' })}
          />
        }
      />
    )}
    <Accordion
      title={t('common:payment:possibilities:avance_immediate')}
      onOpen={() => stores.avanceImmediate.refreshInfos()}
      additionalComponent={
        <AvanceImmediatePaymentType
          proposal={proposal}
          onSelect={() => onSelect({ id: proposal.id, paymentType: 'AVANCE_IMMEDIATE' })}
        />
      }
    />
    <Accordion
      title={t('common:payment:possibilities:transfert')}
      additionalComponent={
        <SelectGardenerButton
          id={proposal.id}
          name={proposal.name}
          onSubmit={() => onSelect({ id: proposal.id, paymentType: 'VIRTUAL_IBAN' })}
          text={t('common:payment:transfert:use_transfert')}
        />
      }
      content={<TransfertPaymentContent walletIban={wallet.iban} isRecurring />}
    />
    <Accordion
      title={t('common:payment:possibilities:cheque')}
      additionalComponent={
        <SelectGardenerButton
          id={proposal.id}
          name={proposal.name}
          onSubmit={() => onSelect({ id: proposal.id, paymentType: 'CHEQUE' })}
          text={t('common:payment:cheque:use_cheque')}
        />
      }
      content={<ChequePaymentContent />}
    />
    <Accordion
      title={t('common:payment:possibilities:cesu')}
      content={<CesuPaymentContent />}
      additionalComponent={
        <SelectGardenerButton
          id={proposal.id}
          name={proposal.name}
          onSubmit={() => onSelect({ id: proposal.id, paymentType: 'CESU' })}
          text={t('common:payment:cesu:use_cesu')}
        />
      }
    />
  </div>
}))

const MandatePaymentType = translate()(({ t, proposal, onSelect }) => {
  const { inquiry } = stores.inquiries
  const { mandate } = stores.account

  // === false is important in these conditions to avoid text flashing on mandate loading
  if (mandate.valid === false) {
    return <DebitPaymentContent />
  }

  if (mandate.signed === false) {
    return <InquiryDetailsTextBlock title={t('common:api:important_notice')} message={t(`common:api:should_sign_sdd`)}>
      <button
        onClick={() => api.inquiries.maintenance.signMandate({ id: inquiry.id })}
        className='btn--green demandes__button'
        style={{ marginTop: '20px' }}>{t(`common:jardiniers:sign_ssd`)}</button>
    </InquiryDetailsTextBlock>
  }

  if (mandate.ready === false) {
    return <InquiryDetailsTextBlock title={t('common:api:an_error_occured')}
      message={`${t(`common:api:errors:${mandate.status}`)} ${t('common:api:please_contact_support')}`} />
  }

  // if all checks are ok, we can allow the user to use
  return <div>
    <div style={{ marginBottom: '20px' }}>
      <span>{t('common:payment:debit:mandate_ready')}</span>
    </div>
    <SelectGardenerButton
      id={proposal.id}
      name={proposal.name}
      onSubmit={onSelect}
      text={t('common:payment:debit:use_mandate')}
    />
  </div>
})

const AvanceImmediatePaymentType = translate()(view(({ t, proposal, onSelect }) => {
  const isAvanceImmediateInfoReadyToUse = stores.avanceImmediate.infos &&
    stores.avanceImmediate.infos.informationProvided &&
    stores.avanceImmediate.infos.usesAvanceImmediate &&
    stores.avanceImmediate.infos.status &&
    stores.avanceImmediate.infos.status.ready
  return <div>
    {
      stores.avanceImmediate.refreshing
        ? <Loader size='small' />
        : (
          isAvanceImmediateInfoReadyToUse
            ? <div>
              <div style={{ marginBottom: '20px' }}>
                <span>{t('common:payment:avance_immediate:enabled')}</span>
              </div>
              <SelectGardenerButton
                id={proposal.id}
                name={proposal.name}
                onSubmit={onSelect}
                text={t('common:payment:avance_immediate:use_avance_immediate')}
              />
            </div>
            : <div>
              <div style={{ marginBottom: '20px' }}>
                <span>{t('common:payment:avance_immediate:disabled')}</span>
              </div>
              <Link className='btn--green'
                to={PagesPaths.AVANCE_IMMEDIATE.path}>{t('common:payment:avance_immediate:configure_avance_immediate')}</Link>
            </div>
        )
    }
  </div>
}))

MaintenanceProposalsWaiting.propTypes = {
  t: func,
  inquiry: object,
  payment: object,
  hidden: bool,
  selected: string,
  onSelect: func,
  type: oneOf(Object.values(InquiryTypes)),
  frequency: oneOf(Object.values(InquiryFrequencies))
}



// WEBPACK FOOTER //
// ./src/pages/demandes/maintenances/MaintenanceProposalsWaiting.js